$(function() {
    var loc = location.pathname.trim();
    var query = $.deparam.querystring();
    if (query["sa"] != null) {
        var subjecareaid = query["sa"];
        var lisubjectarea = $("li[id= '" + subjecareaid + "']");
        lisubjectarea.removeClass('mnmiddle').addClass('mnmiddleselected');
    }
    else {

        if ($("[href='" + loc + "']").closest('li').hasClass('mntop')) {
            $("[href='" + loc + "']").closest('li').removeClass('mntop').addClass('mntopselected');
        }
        else {
            $("[href='" + loc + "']").closest('li').removeClass('mnmiddle').addClass('mnmiddleselected');
        }
    }
});